<template>
  <v-sheet
    background-color="transparent"
    width="100%"
    height="100%"
    class="d-flex align-center py-6 py-md-10 py-lg-16 relative item"
    :style="item.img ? `background-image: url(${files + item.img});` : ``"
  >
    <v-container class="relative">
      <div
        class="
          text-h6 text-sm-h5 text-md-h4 text-lg-h3
          primary--text
          text-center
        "
        v-if="item.subtitle"
      >
        {{ item.subtitle }}
      </div>
      <div
        class="
          text-h5 text-sm-h4 text-md-h3 text-lg-h2
          font-weight-bold
          primary--text
          mt-3
          text-center
        "
        v-if="item.title"
      >
        {{ item.title }}
      </div>

      <Form class="mt-6 mt-md-10 mt-lg-16" />
    </v-container>
  </v-sheet>
</template>

<script>
import Form from "../../forms/Home.vue";

const _config = {
  path: `/imoveis`,
  mod: `home-config`,
};

export default {
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
  },
  components: {
    Form,
  },
};
</script>

<style lang="scss" scoped>
.item {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  &:before {
    background-color: rgba(255, 255, 255, 0.8);
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
}
</style>
